<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" class="contact-component">
  <label>{{ 'CONTACT_COMPONENT.CONTACTS' | translate }}</label>
  <div formArrayName="contacts" class="d-flex flex-wrap bg">
    <div
      *ngFor="let contact of parentFormGroup.get('contacts')?.controls; let ci = index"
      class="single-contact px-1"
      [ngClass]="'col-sm-' + colsCalculated"
    >
      <button
        type="button"
        class="remove-contact"
        (click)="removeContact(ci)"
        *ngIf="parentFormGroup.get('contacts').controls.length > 1 || !required"
      >
        <i class="fal fa-times"></i>
      </button>
      <div [formGroupName]="ci">
        <div class="row g-0">
          <div class="col-sm-4">
            <div class="form-group">
              <app-type-select
                [parentFormGroup]="contact"
                [groupType]="'contacts'"
                [passFormControlName]="'type_id'"
                [bindValue]="'id'"
                class="contact-type-select"
              ></app-type-select>
            </div>
          </div>
          <div [ngClass]="showNote ? 'col-sm-4' : 'col-sm-8'">
            <div class="form-group">
              <input
                type="text"
                class="form-control form-control-contact-value"
                formControlName="value"
                placeholder="{{ 'CONTACT_COMPONENT.VALUE' | translate }}"
                (blur)="onContactBlur(ci)"
                (paste)="onPaste(ci)"
                [ngClass]="{
                    'is-invalid': contact.get('value').invalid && contact.get('value').touched
                  }"
              />
              <div
                *ngIf="contact.get('value').errors?.invalidPhone && contact.get('value').touched"
                class="invalid-feedback d-block"
              >
                {{ 'CONTACT_COMPONENT.INVALID_PHONE' | translate }}
              </div>
              <div
                *ngIf="(contact.get('duplicate').value || contact.get('duplicateMessage').value) && (contact.get('value').touched || contact.get('duplicateChecked').value)"
                class="invalid-feedback d-block"
              >
                <span *ngIf="contact.get('duplicateMessage').value">{{ contact.get('duplicateMessage').value }}</span>
                <span *ngIf="!contact.get('duplicateMessage').value">{{ getDuplicateContactMessage(contact.get('type_id').value) | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="showNote">
            <div class="form-group">
              <input type="text" class="form-control form-control-contact-note" formControlName="note" placeholder="{{ 'CONTACT_COMPONENT.NOTE' | translate }}" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="'col-sm-' + colsCalculated" class="px-1">
      <button type="button" class="btn btn-input btn-outline-primary mb-2" (click)="addContact()">
        {{ 'CONTACT_COMPONENT.ADD_CONTACT' | translate }}
      </button>
    </div>
  </div>
</div>
